import {useIntegrator} from "../../integrator.context";
import {MetadataCollection} from "../../commands/metadataValue.command";
import {AddConstantUnitAttribute} from "../../commands/addConstantUnitAttribute.command";
import {RemoveConstantUnitAttribute} from "../../commands/removeConstantUnitAttribute.command";
import {AddConstantBuildingAttribute} from "../../commands/addConstantBuildingAttribute.command";
import {RemoveConstantBuildingAttribute} from "../../commands/removeConstantsBuildingAttribute.command";
import MetadataColumn from "../../elements/metadataColumn.element";
import {useApp} from "../../app.context";

function AttributesEditor() {
    const {state, executeCommand} = useIntegrator();
    const {isHiddenUnitAttribute} = useApp();

    // Unit Attributes shows visible (capability) attributes; Unit Types shows
    // [AttributeHidden] markers (e.g. Ranged, Melee) which are auto-seeded
    // from the manifest and have no parameters by construction.
    const visibleUnitAttributes = (state.unitAttributes ?? []).filter(a => !isHiddenUnitAttribute(a.id));
    const hiddenUnitAttributes = (state.unitAttributes ?? []).filter(a => isHiddenUnitAttribute(a.id));

    return (
        <div className={'layout horizontal flex-grow'} style={{gap: 12, overflowX: 'auto'}}>
            <MetadataColumn title={'Unit Attributes'} attributes={visibleUnitAttributes} collection={MetadataCollection.Units}
                            add={(uid) => executeCommand(new AddConstantUnitAttribute(uid))}
                            remove={(uid) => executeCommand(new RemoveConstantUnitAttribute(uid))}/>
            <MetadataColumn title={'Unit Types'} attributes={hiddenUnitAttributes} collection={MetadataCollection.Units}
                            allowAdd={false}
                            add={() => {}}
                            remove={(uid) => executeCommand(new RemoveConstantUnitAttribute(uid))}/>
            <MetadataColumn title={'Building Attributes'} attributes={state.buildingAttributes} collection={MetadataCollection.Buildings}
                            add={(uid) => executeCommand(new AddConstantBuildingAttribute(uid))}
                            remove={(uid) => executeCommand(new RemoveConstantBuildingAttribute(uid))}/>
        </div>
    );
}

export default AttributesEditor;
